module.exports = __webpack_public_path__ + "static/media/LowStart-upCost.3f2ebebb.svg";